import React from "react";

import { withTranslation } from "react-i18next";
import "./style.scss";
import Item from "../Item";

const ItemGroup = (props) => {
  const { parentItem = {},
    childList = [],
    handleSelect = () => { },
    itemStatus = [],
    theme } = props;

  const onParentCheck = (value, id) => {
    let newItemStatus = { ...itemStatus, [id]: value };
    //If parent unCheck -> all child will uncheck
    if (!value) {
      childList.forEach((item) => {
        newItemStatus[item.id] = false;
      });
    }
    handleSelect(newItemStatus, id);
  };

  const onChildCheck = (value, id) => {
    if(parentValue) {
      let newItemStatus = { ...itemStatus, [id]: value };
      handleSelect(newItemStatus, id);
    }
  };
  const parentValue = itemStatus[parentItem.id] || false;
  
  return (
    <div className="box-content">
      <div className="parent-item">
        <Item
          key={parentItem.id}
          id={parentItem.id}
          analyticIds={parentItem.analytic}
          title={parentItem.title}
          checked={parentValue}
          onChange={onParentCheck}
          detail={parentItem.detail}
          description={parentItem.description}
          theme={theme}
        />
      </div>
      <div className="child-item">
        {childList.map((item) => (
          <Item
            key={item.id}
            id={item.id}
            analyticIds={item.analytic}
            title={item.title}
            checked={!parentValue ? false : (itemStatus[item.id] ? itemStatus[item.id] : false)}
            onChange={onChildCheck}
            detail={item.detail}
            description={item.description}
            disabled={!parentValue}
            theme={theme}
          />
        ))}
      </div>
    </div>
  ); 
};

export default withTranslation()(ItemGroup);
